/* tslint:disable:no-bitwise */
import {BriefPanelName, PanelTypeEnum, Unit, VAxisType} from '@balrog/component/types';
import {AccessPermissionEnum} from '@balrog/core/model/const';
/* eslint no-bitwise: ["error", { "allow": ["&", "<<"] }] */
import {ProfileInterface} from './interface/profile.interface';
import {ScheduleboardConfigInterface} from './interface/scheduleboard-config.interface';

export class SmartventProfileV2 implements ProfileInterface {
    statuses = {};
    alarms = {};

    briefPanel = {
        name: BriefPanelName.SMARTVENT
    };

    dashBoard = {
        panelType: PanelTypeEnum.SMARTVENT,
        panelConfig: {
            mode: 'V2'
        }
    };

    historyBoard = {
        title: '',
        content: [{
            paramId: 'TEMP_CZERPNI'
        }, {
            paramId: 'TEMP_WYRZUTNI'
        }, {
            paramId: 'TEMP_NAWIEW'
        }, {
            paramId: 'TEMP_WYWIEW'
        }, {
            paramId: 'HUM_CZERPNI',
            vAxisType: VAxisType.PERCENTAGE.valueOf()
        }, {
            paramId: 'HUM_WYRZUTNI',
            vAxisType: VAxisType.PERCENTAGE.valueOf()
        }, {
            paramId: 'HUM_NAWIEW',
            vAxisType: VAxisType.PERCENTAGE.valueOf()
        }, {
            paramId: 'HUM_WYWIEW',
            vAxisType: VAxisType.PERCENTAGE.valueOf()
        }, {
            paramId: 'MOC_WENT',
            type: 'stepped',
            vAxisType: VAxisType.PERCENTAGE.valueOf()
        }]
    };

    listBoard = {
        title: 'Konfiguracja urządzenia',
        content: [{
            paramId: 'TRYB_PANEL',
            type: 'ITEM-SELECT',
            options: [
                {value: '0', name: 'Brak'},
                {value: '1', name: 'Automatyczny'},
                {value: '2', name: 'Wietrzenie'},
                {value: '3', name: 'Noc'},
                {value: '4', name: 'Kalendarz'},
                {value: '5', name: 'Kominek'}
            ]
        }, {
            paramId: 'TEMP_NAWIEW',
            readPermission: AccessPermissionEnum.SERVICE.valueOf(),
            unit: Unit.C,
            step: 0.1
        }, {
            paramId: 'TEMP_WYWIEW',
            readPermission: AccessPermissionEnum.SERVICE.valueOf(),
            unit: Unit.C,
            step: 0.1
        }, {
            paramId: 'TEMP_CZERPNI',
            readPermission: AccessPermissionEnum.SERVICE.valueOf(),
            unit: Unit.C,
            step: 0.1
        }, {
            paramId: 'TEMP_WYRZUTNI',
            readPermission: AccessPermissionEnum.SERVICE.valueOf(),
            unit: Unit.C,
            step: 0.1
        }, {
            paramId: 'NST_MOC_WENT_NAWIEW',
            unit: Unit.PERCENTAGE
        }, {
            paramId: 'WENT_NAWIEW',
            readPermission: AccessPermissionEnum.SERVICE.valueOf(),
            unit: Unit.RPM
        }, {
            paramId: 'NST_MOC_WENT_WYWIEW',
            unit: Unit.PERCENTAGE
        }, {
            paramId: 'WENT_WYWIEW',
            readPermission: AccessPermissionEnum.SERVICE.valueOf(),
            unit: Unit.RPM
        }, {
            paramId: 'HUM_NAWIEW',
            unit: Unit.PERCENTAGE
        }, {
            paramId: 'HUM_WYWIEW',
            unit: Unit.PERCENTAGE,
            readPermission: AccessPermissionEnum.SERVICE.valueOf()
        }, {
            paramId: 'HUM_CZERPNI',
            unit: Unit.PERCENTAGE,
            readPermission: AccessPermissionEnum.SERVICE.valueOf()
        }, {
            paramId: 'HUM_WYRZUTNI',
            unit: Unit.PERCENTAGE,
            readPermission: AccessPermissionEnum.SERVICE.valueOf()
        }, {
            paramId: 'MOC_WENT',
            unit: Unit.PERCENTAGE,
            readPermission: AccessPermissionEnum.SERVICE.valueOf()
        }, {
            paramId: 'CZAS_WYMIANY_FILTRA',
            unit: Unit.DAY
        }, {
            paramId: 'NAST_TEMP_DOGRZEWANIA',
            unit: Unit.C
        }, {
            paramId: 'DOGRZEWANIE',
            type: 'ITEM-SWITCH',
            options: [{value: 'false', name: 'wył.'}, {value: 'true', name: 'wł.'}]
        }, {
            paramId: 'NAST_TEMP_CHLODZENIA',
            unit: Unit.C
        }, {
            paramId: 'CHLODZENIE',
            type: 'ITEM-SWITCH',
            options: [{value: 'false', name: 'wył.'}, {value: 'true', name: 'wł.'}]
        }, {
            paramId: 'SLAVE_ERR',
            type: 'ITEM-TEXT',
            inputConverter(v: number) {
                const text = [];
                if (v & (1 << 6)) {text.push('Błąd czerpnia'); }
                if (v & (1 << 7)) {text.push('Błąd wyrzutnia'); }
                if (v & (1 << 8)) {text.push('Błąd nawiew'); }
                if (v & (1 << 9)) {text.push('Błąd wywiew'); }
                if (v & (1 << 10)) {text.push('Błąd ext 1'); }
                if (v & (1 << 11)) {text.push('Błąd ext 2'); }
                return text.length ? text.join(',') : '---';
            }
        }, {
            type: 'ITEM-TEXT',
            paramId: 'WERSJA_FIRMWARE'
        }, {
            type: 'ITEM-TEXT',
            paramId: 'WERSJA_HARDWARE'
        }, {
            paramId: 'NOW_TIME',
            type: 'ITEM-TEXT',
            placeholder: 'HH-MM'
        }, {
            paramId: 'NOW_DATE',
            type: 'ITEM-TEXT',
            placeholder: 'yyyy-mm-dd'
        }, {
            paramId: 'NOW_DAY_OF_WEEK',
            type: 'ITEM-SELECT',
            readonly: true,
            options: [
                {value: '0', name: 'Poniedziałek'},
                {value: '1', name: 'Wtorek'},
                {value: '2', name: 'Środa'},
                {value: '3', name: 'Czwartek'},
                {value: '4', name: 'Piątek'},
                {value: '5', name: 'Sobota'},
                {value: '6', name: 'Niedziela'}
            ]
        }, {
            title: 'Ustawienia',
            readPermission: AccessPermissionEnum.SERVICE.valueOf(),
            type: 'MENU',
            content: [
                {
                    paramId: 'EEP_MAX_TEMP_PRACY',
                    unit: Unit.C
                },
                {
                    paramId: 'EEP_BYPASS_MIN',
                    unit: Unit.C
                },
                {
                    paramId: 'EEP_BYPASS_MAX',
                    unit: Unit.C
                },
                {
                    paramId: 'EEP_TEMP_ODMRAZANIA_EFFICIENCY',
                    unit: Unit.C
                },
                {
                    paramId: 'EEP_TEMP_ODMRAZANIA_STANDARD',
                    unit: Unit.C
                },
                {
                    paramId: 'EEP_TEMP_ODMRAZANIA_SSA',
                    unit: Unit.C
                },
                {
                    paramId: 'EEP_CZAS_DOGRZEWANIA',
                    unit: Unit.SEC
                },
                {
                    paramId: 'EEP_CZAS_PRZERWY',
                    unit: Unit.SEC
                },
                {
                    paramId: 'EEP_MOC_ODMRAZANIA',
                    unit: Unit.PERCENTAGE
                },
                {
                    paramId: 'EEP_MOC_ODMRAZANIA_MAX',
                    unit: Unit.PERCENTAGE
                },
                {
                    paramId: 'EEP_TEMP_DOGRZEWANIA',
                    unit: Unit.C
                },
                {
                    paramId: 'EEP_SERWO_BYPASS_MIN'
                },
                {
                    paramId: 'EEP_SERWO_BYPASS_MAX'
                },
                {
                    paramId: 'EEP_SERWO_PREDKOSC'
                },
                {
                    paramId: 'EEP_CZAS_WYMIANY_FILTRA',
                    unit: Unit.DAY
                },
                {
                    paramId: 'EEP_CZAS_WYCHLADZANIA_GRZALEK',
                    unit: Unit.SEC
                },
                {
                    paramId: 'EEP_MAX_MOC_WENT_NAWIEW',
                    unit: Unit.PERCENTAGE
                },
                {
                    paramId: 'EEP_MAX_MOC_WENT_WYWIEW',
                    unit: Unit.PERCENTAGE
                },
                {
                    paramId: 'EEP_CZAS_TRYBU_BOOST',
                    unit: Unit.MIN
                },
                {
                    paramId: 'EEP_CZAS_TRYBU_NOC',
                    unit: Unit.MIN
                },
                {
                    paramId: 'EEP_CZAS_TRYBU_KOMINEK',
                    unit: Unit.MIN
                },
            ]
        }]
    };

    scheduleBoard: ScheduleboardConfigInterface = {
        title: 'Kalendarz',
        event: [
            {
                paramId: 'NST_MOC_WENT_NAWIEW',
                defaultValue: 20,
                unit: Unit.PERCENTAGE
            },
            {
                paramId: 'NST_MOC_WENT_WYWIEW',
                defaultValue: 20,
                unit: Unit.PERCENTAGE
            },
            {
                paramId: 'TEMP_NAWIEW',
                defaultValue: 20,
                unit: Unit.C
            },
            {
                paramId: 'BOOST_MODE',
                displayType: 'ITEM-SWITCH',
                options: [{value: 'false', name: 'wył.'}, {value: 'true', name: 'wł.'}]
            },
            {
                paramId: 'DOGRZEWANIE',
                displayType: 'ITEM-SWITCH',
                options: [{value: 'false', name: 'wył.'}, {value: 'true', name: 'wł.'}]
            }
        ]
    };
}

